const servicename = [
    {
        servicetag: "tech strategy",
        servicename: "UI/UX Design",
        serviceicon: "/images/service/uiux.png",
        servicedesc: "From strategy and brand, to web and product design, I help teams bring businesses to life with modern, memorable and minimal creative work."
    },

    {
        servicetag: "tech strategy",
        servicename: "Web Development",
        serviceicon: "/images/service/webdev.png",
        servicedesc: "From strategy and brand, to web and product design, I help teams bring businesses to life with modern, memorable and minimal creative work."
    },

    {
        servicetag: "tech strategy",
        servicename: "Website Manager",
        serviceicon: "/images/service/webmanager.png",
        servicedesc: "From strategy and brand, to web and product design, I help teams bring businesses to life with modern, memorable and minimal creative work."
    },

]

export default servicename;